import React, { useEffect, useState } from 'react'

export const store = React.createContext();

export default function State({children}) {
    const [selectedLang, setSelectedLang] = useState(localStorage.getItem("lang") || "arm")

    useEffect(() => {
        localStorage.setItem("lang", selectedLang);
    }, [selectedLang])

    const value = {
        selectedLang,
        setSelectedLang,
    }
  return (
    <store.Provider value={value}>
        {children}
    </store.Provider>
  )
}
